import { render, staticRenderFns } from "./IconHierarchy.vue?vue&type=template&id=0ea97e98&"
import script from "./IconHierarchy.vue?vue&type=script&lang=ts&"
export * from "./IconHierarchy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports